import { ColorTheme } from './FileDropZone.types';

export const DEFAULT_MAX_SIZE_BYTES = 50 * 1024 * 1024; // 50MB

export const ACCEPTED_FILE_TYPES: Record<string, Record<string, string[]>> = {
  all: {
    'application/pdf': ['.pdf'],
    'text/plain': ['.txt', '.csv'],
    'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
  },
  images: {
    'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp'],
  },
  documents: {
    'application/pdf': ['.pdf'],
    'text/plain': ['.txt'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'application/rtf': ['.rtf'],
  },
  spreadsheets: {
    'text/plain': ['.csv'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
  },
  media: {
    'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp'],
    'video/*': ['.mp4', '.avi', '.mov', '.webm'],
  },
};

export const COLOR_THEMES: Record<
  ColorTheme,
  {
    border: string;
    bg: string;
    hoverBorder: string;
    hoverBg: string;
    icon: string;
    darkBg: string;
    darkBorder: string;
  }
> = {
  amber: {
    border: 'border-amber-400',
    bg: 'bg-amber-50/50',
    hoverBorder: 'hover:border-amber-400',
    hoverBg: 'hover:bg-amber-50/50',
    icon: 'text-amber-500',
    darkBg: 'dark:bg-amber-900/10',
    darkBorder: 'dark:border-amber-500',
  },
  blue: {
    border: 'border-blue-400',
    bg: 'bg-blue-50/50',
    hoverBorder: 'hover:border-blue-400',
    hoverBg: 'hover:bg-blue-50/50',
    icon: 'text-blue-500',
    darkBg: 'dark:bg-blue-900/10',
    darkBorder: 'dark:border-blue-500',
  },
  green: {
    border: 'border-green-400',
    bg: 'bg-green-50/50',
    hoverBorder: 'hover:border-green-400',
    hoverBg: 'hover:bg-green-50/50',
    icon: 'text-green-500',
    darkBg: 'dark:bg-green-900/10',
    darkBorder: 'dark:border-green-500',
  },
  indigo: {
    border: 'border-indigo-400',
    bg: 'bg-indigo-50/50',
    hoverBorder: 'hover:border-indigo-400',
    hoverBg: 'hover:bg-indigo-50/50',
    icon: 'text-indigo-500',
    darkBg: 'dark:bg-indigo-900/10',
    darkBorder: 'dark:border-indigo-500',
  },
};

export const DEFAULT_TEXTS = {
  title: 'Drag & drop files here, or click to select',
  subtitle: 'PDF, DOC, XLS, images up to 50MB each',
  dragActiveText: 'Drop files here...',
  uploadingText: 'Uploading files...',
};
